/* Manual browsing only. Judge.me remains the source and native review widget. */
(() => {
  const init = (root = document) => root.querySelectorAll('[data-gg-review-browser]').forEach(browser => {
    if (browser.dataset.reviewReady) return;
    const track = browser.querySelector('.ggl-review-track--scroll');
    const controls = browser.querySelector('[data-review-controls]');
    if (!track || !controls) return;
    const cards = Array.from(track.children);
    if (cards.length <= 2) return;
    browser.dataset.reviewReady = 'true';
    const prev = controls.querySelector('[data-review-prev]');
    const next = controls.querySelector('[data-review-next]');
    const position = controls.querySelector('[data-review-position]');
    const stride = () => cards[1].offsetLeft - cards[0].offsetLeft;
    const update = () => {
      const rect = track.getBoundingClientRect();
      const visible = cards.map((card, i) => ({ i, rect: card.getBoundingClientRect() })).filter(card => card.rect.right > rect.left + 4 && card.rect.left < rect.right - 4);
      const first = (visible[0]?.i || 0) + 1;
      const last = (visible[visible.length - 1]?.i || 0) + 1;
      position.textContent = `${first === last ? first : `${first}–${last}`} of ${cards.length}`;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    };
    const move = (direction) => track.scrollBy({left: stride() * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('keydown', event => {
      if (event.target !== track || event.ctrlKey || event.metaKey || event.altKey) return;
      if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') track.scrollTo({left:event.key === 'Home' ? 0 : track.scrollWidth, behavior:'auto'});
        else move(event.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    track.addEventListener('scroll', update, {passive:true});
    new ResizeObserver(update).observe(track);
    controls.hidden = false;
    update();
  });
  init();
  if (!window.ggReviewCarouselListener) {
    window.ggReviewCarouselListener = true;
    document.addEventListener('shopify:section:load', event => init(event.target));
  }
})();
